import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "advanced-search-filters" }
const _hoisted_2 = { class: "filter-row filter-row--primary" }
const _hoisted_3 = { class: "filter-group" }
const _hoisted_4 = { class: "filter-group" }
const _hoisted_5 = { class: "filter-group" }
const _hoisted_6 = {
  key: 0,
  class: "filter-row filter-row--custom-dates custom-date-range"
}
const _hoisted_7 = { class: "filter-group" }
const _hoisted_8 = { class: "filter-group" }

import { onBeforeUnmount, onMounted, ref } from 'vue';

import { Input, Select, type SelectOption } from '@/components/ui';
import {
  registerAdvancedSearchFiltersController,
  unregisterAdvancedSearchFiltersController,
  type AdvancedSearchDateRangeFilter,
  type AdvancedSearchFiltersController
} from './advanced-search-filters-controller';


export default /*@__PURE__*/_defineComponent({
  __name: 'AdvancedSearchFilters',
  setup(__props) {

const dateRange = ref('');
const dateStart = ref('');
const dateEnd = ref('');
const courier = ref('');
const stage = ref('');

const dateRangeOptions: SelectOption[] = [
  { value: '', label: 'Any time' },
  { value: 'last_7_days', label: 'Last 7 days' },
  { value: 'last_30_days', label: 'Last 30 days' },
  { value: 'last_90_days', label: 'Last 90 days' },
  { value: 'this_month', label: 'This month' },
  { value: 'last_month', label: 'Last month' },
  { value: 'custom', label: 'Custom...' }
];

const courierOptions: SelectOption[] = [
  { value: '', label: 'Any courier' },
  { value: 'FedEx', label: 'FedEx' },
  { value: 'UPS', label: 'UPS' },
  { value: 'DHL', label: 'DHL' },
  { value: 'CEVA', label: 'CEVA' },
  { value: 'dayross', label: 'Day & Ross' },
  { value: 'abf', label: 'ABF' },
  { value: 'dbschenker', label: 'DB Schenker' }
];

const stageOptions: SelectOption[] = [
  { value: '', label: 'Any stage' },
  { value: 'active', label: 'Active' },
  { value: 'delivered', label: 'Delivered' },
  { value: 'closed', label: 'Closed' },
  { value: 'exception', label: 'Exception' },
  { value: 'returned', label: 'Returned' }
];

function getDateRangeFilter(): AdvancedSearchDateRangeFilter | undefined {
  if (!dateRange.value) {
    return undefined;
  }

  const now = new Date();
  let startDate: Date | undefined;
  let endDate: Date | undefined;

  switch (dateRange.value) {
    case 'last_7_days':
      startDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      endDate = now;
      break;
    case 'last_30_days':
      startDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
      endDate = now;
      break;
    case 'last_90_days':
      startDate = new Date(now.getTime() - 90 * 24 * 60 * 60 * 1000);
      endDate = now;
      break;
    case 'this_month':
      startDate = new Date(now.getFullYear(), now.getMonth(), 1);
      endDate = now;
      break;
    case 'last_month':
      startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      endDate = new Date(now.getFullYear(), now.getMonth(), 0);
      break;
    case 'custom':
      if (dateStart.value) {
        startDate = new Date(dateStart.value);
      }
      if (dateEnd.value) {
        endDate = new Date(dateEnd.value);
        endDate.setHours(23, 59, 59, 999);
      }
      break;
    default:
      return undefined;
  }

  if (!startDate) {
    return undefined;
  }

  return {
    field: 'date_shipped',
    start: Math.floor(startDate.getTime() / 1000),
    end: endDate ? Math.floor(endDate.getTime() / 1000) : undefined
  };
}

const controller: AdvancedSearchFiltersController = {
  getCourier: () => courier.value,
  getStage: () => stage.value,
  getDateRangeFilter,
  reset: () => {
    dateRange.value = '';
    dateStart.value = '';
    dateEnd.value = '';
    courier.value = '';
    stage.value = '';
  }
};

onMounted(() => {
  registerAdvancedSearchFiltersController(controller);
});

onBeforeUnmount(() => {
  unregisterAdvancedSearchFiltersController(controller);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("label", { for: "advancedSearchFilterDateRange" }, "Date Range", -1 /* CACHED */)),
        _createVNode(_unref(Select), {
          id: "advancedSearchFilterDateRange",
          modelValue: dateRange.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateRange).value = $event)),
          class: "advanced-search-filter-select",
          options: dateRangeOptions,
          "aria-label": "Date range",
          variant: "form",
          "prefer-placement": "top"
        }, null, 8 /* PROPS */, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[6] || (_cache[6] = _createElementVNode("label", { for: "advancedSearchFilterCourier" }, "Courier", -1 /* CACHED */)),
        _createVNode(_unref(Select), {
          id: "advancedSearchFilterCourier",
          modelValue: courier.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((courier).value = $event)),
          class: "advanced-search-filter-select",
          options: courierOptions,
          "aria-label": "Courier",
          variant: "form",
          "prefer-placement": "top"
        }, null, 8 /* PROPS */, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[7] || (_cache[7] = _createElementVNode("label", { for: "advancedSearchFilterStage" }, "Stage", -1 /* CACHED */)),
        _createVNode(_unref(Select), {
          id: "advancedSearchFilterStage",
          modelValue: stage.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((stage).value = $event)),
          class: "advanced-search-filter-select",
          options: stageOptions,
          "aria-label": "Stage",
          variant: "form",
          "prefer-placement": "top"
        }, null, 8 /* PROPS */, ["modelValue"])
      ])
    ]),
    (dateRange.value === 'custom')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "advancedSearchFilterDateStart" }, "Start", -1 /* CACHED */)),
            _createVNode(_unref(Input), {
              id: "advancedSearchFilterDateStart",
              modelValue: dateStart.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dateStart).value = $event)),
              type: "date",
              class: "advanced-search-filter-input",
              variant: "form"
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { for: "advancedSearchFilterDateEnd" }, "End", -1 /* CACHED */)),
            _createVNode(_unref(Input), {
              id: "advancedSearchFilterDateEnd",
              modelValue: dateEnd.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dateEnd).value = $event)),
              type: "date",
              class: "advanced-search-filter-input",
              variant: "form"
            }, null, 8 /* PROPS */, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})